import { Button, Modal } from 'shared/components/ui';
import React from 'react';

import { Refresh, Logout } from '@mui/icons-material';

const VersionModal = ({ show, forceLogout, onConfirm }) => {
  return (
    <Modal show={show} backdrop="static" keyboard={false} centered>
      <Modal.Header>
        <Modal.Title>
          <Refresh sx={{ mr: 1, verticalAlign: 'middle' }} />
          Nueva Versión Disponible
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Hay una nueva versión de la aplicación disponible.</p>
        {forceLogout ? (
          <p>Para continuar usando el sistema, debe cerrar sesión y volver a iniciar sesión.</p>
        ) : (
          <p>Para ver los cambios, debe recargar la página.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onConfirm}>
          {forceLogout ? (
            <><Logout sx={{ fontSize: 18, mr: 0.5 }} /> Cerrar Sesión</>
          ) : (
            <><Refresh sx={{ fontSize: 18, mr: 0.5 }} /> Recargar Página</>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VersionModal;
